export const getUserGroupsSuccess = (userGroups) => {
    return {
        type: "GET_USER_GROUPS_SUCCESS",
        payload: userGroups
    }
};
